import { useCallback, useEffect, useState } from "react";
import { MOBILE_DEVICE_REGEX } from "../index";

// Breakpoints should match your CSS breakpoints
const BREAKPOINTS = {
  desktop: 992,
  tablet: 768,
};

const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false;

  return MOBILE_DEVICE_REGEX.test(navigator.userAgent);
};

export function useDevice() {
  const getDeviceState = useCallback(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    ) {
      return {
        isDesktop: false,
        isTablet: false,
        isMobile: true,
      };
    }

    const mobileDevice = isMobileDevice();

    // FORCE mobile layout on actual phones/tablets
    if (mobileDevice) {
      return {
        isDesktop: false,
        isTablet: false,
        isMobile: true,
      };
    }

    // Normal responsive behavior for desktop browsers
    const isDesktop = window.matchMedia(
      `(min-width: ${BREAKPOINTS.desktop}px)`,
    ).matches;

    const isTablet =
      !isDesktop &&
      window.matchMedia(`(min-width: ${BREAKPOINTS.tablet}px)`).matches;

    const isMobile = !isDesktop && !isTablet;

    return {
      isDesktop,
      isTablet,
      isMobile,
    };
  }, []); // Empty deps—BREAKPOINTS is stable

  const [sizes, setSizes] = useState(() => getDeviceState());

  useEffect(() => {
    const handler = () => {
      setSizes(getDeviceState());
    };

    window.addEventListener("resize", handler);
    window.addEventListener("orientationchange", handler);

    handler();

    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("orientationchange", handler);
    };
  }, [getDeviceState]); // Now safe to include

  return sizes;
}

export default useDevice;
